import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShowLoaderScreenService } from './core/services/show-loader-screen.service';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet , ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('wallet');

  constructor(_ShowLoaderScreenService : ShowLoaderScreenService){
    // _ShowLoaderScreenService.show();
  }
}
